'use strict';

/**
 * @description Wrapper for Axios request interceptor. Catches all outbound requests
 * @param {object} config The request object
 */
function defaultRequestInterceptor (config) {
  return config;
}

export default defaultRequestInterceptor;